import * as React from "react";
import { SVGProps, memo } from "react";
const SvgCloseButton = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="close-button_svg__$state$"
    width={14}
    height={14}
    role="img"
    {...props}
  >
    <style />
    <path
      d="m7.7 7 4.7-4.7c.2-.2.2-.5 0-.7s-.5-.2-.7 0L7 6.3 2.3 1.6c-.2-.2-.5-.2-.7 0s-.2.5 0 .7L6.3 7l-4.7 4.7c-.2.2-.2.5 0 .7s.5.2.7 0L7 7.7l4.7 4.7c.2.2.5.2.7 0s.2-.5 0-.7L7.7 7z"
      style={{
        fill: "#666",
      }}
    />
  </svg>
);
const Memo = memo(SvgCloseButton);
export default Memo;
